
import { includesValidator } from '../../common/utils/validator';

const MenuItemSize = {
  Medium: 'medium',
  Small: 'small',
};
const IconSize = {
  Small: 'small',
  Medium: 'medium',
};
export default {
  name: 'BbMenuItem',
  props: {
    size: {
      type: String,
      default: MenuItemSize.Medium,
      validator: includesValidator(MenuItemSize),
    },
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: IconSize.Small,
      validator: includesValidator(IconSize),
    },
    description: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
